<template>
  <div class="study-sets">
    <div>
      <h4 class="review-title" @click="handleView">
        {{ $t("homework.study_sets") }}
        <span> {{ formatSSCount(count) }}</span>
        <i
          class="ml-px-16"
          v-bind:class="
            isExpand ? 'elsa-chevron-circle-up' : 'elsa-chevron-circle-down'
          "
        />
      </h4>
    </div>
    <elsa-tree
      :data="treeData"
      @action-edit="handleEdit"
      accordion
      default-expand-all
      icon-class="tree-icon"
      v-if="isExpand"
      v-loading="loading"
    >
      <template v-slot:title="{ node }">
        <span v-bind:class="node.data.options.titleClassArray">
          {{ node.label }}
        </span>
      </template>
    </elsa-tree>
    <edit-study-set-wrapper ref="editStudySetWrapper" />
  </div>
</template>

<script>
import EditStudySetWrapper from "@/components/modals/studysets/EditStudySetWrapper";
import ElsaTree from "@/components/common/Tree";
import { warningMessage } from "@/utils/messages";
import { mapActions } from "vuex";

export default {
  components: {
    ElsaTree,
    EditStudySetWrapper,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: { type: Boolean, default: true },
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label",
      },
      expanded: {},
      treeData: [],
      count: 0,
      isExpand: true,
      showEditDisabledNotification: false,
    };
  },
  mounted() {
    this.parseData();
  },
  methods: {
    ...mapActions({
      checkStudySetPermissionAction: "studysets/checkStudySetPermission",
    }),
    formatSSCount(number) {
      if (number > 1) {
        return `${number} ${this.$t(`common.items`)}`;
      } else {
        return `${number} ${this.$t(`common.item`)}`;
      }
    },
    async parseData() {
      const tree = [];
      const ids = [];
      this.data.map((row) => {
        const root = {
          id: row.id,
          label: row.name,
          children: [],
          options: {
            showIcon: true,
            iconClassArray: ["elsa-grip-lines"],
            titleClassArray: ["level-title", "root-title"],
            showEditAction: true,
            editDisabled: true,
            editActionText: this.$t('study_sets.edit_study_set')
          },
        };
        ids.push(row.id);
        root.children = this.appendPhrases(row.phrases);
        if (root.children.length > 0) {
          tree.push(root);
        }
      });
      const treeWithPermission = await this.handleCheckStudySetPermission(
        ids,
        tree
      );
      this.treeData = treeWithPermission;
    },

    appendPhrases(phrases) {
      const data = [];
      phrases.forEach((phrase, index) => {
        this.count++;
        data.push({
          id: index,
          label: phrase,
          options: {
            showIcon: true,
            titleClassArray: ["level-title", "level-2-title"],
          },
        });
      });
      return data;
    },

    getTitleByLevel(node) {
      let prefix = "";
      if (node.level === 1)
        prefix = this.$t("homework.study_sets_title_skill", [node.data.order]);
      if (node.level === 2)
        prefix = this.$t("homework.study_sets_title_level", [node.data.order]);
      return prefix + node.label;
    },

    handleView() {
      this.isExpand = !this.isExpand;
    },

    handleEdit(data) {
      if (data.options.editDisabled) {
        return warningMessage(this.$t("study_sets.edit_disabled_message"), 'elsa-message info')(this);
      } else {
        this.$refs.editStudySetWrapper.init(data.id);
      }
    },

    async handleCheckStudySetPermission(studySetIds, tree) {
      try {
        const checkedStudySets = await this.checkStudySetPermissionAction(
          studySetIds
        );
        tree.map((row) => {
          row.options.editDisabled = !checkedStudySets.edit.includes(row.id);
        });
        return tree;
      } catch (error) {
        error;
      }
    },
  },
  watch: {
    data() {
      this.parseData();
    },
  },
};
</script>

<style lang="scss" scoped>
.study-sets {
  border: 1px solid #efeff4;
  margin-bottom: 40px;
  border-radius: 12px;

  ::v-deep .el-tree {
    border: unset;
  }

  ::v-deep .el-tree-node__content {
    border-top: 1px solid #e5e5ea;
    border-bottom: unset;
  }
}

.review-title {
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 32px;
  margin: 0;

  span {
    font-size: 14px;
    line-height: 17px;
    background: #007eff;
    border-radius: 100px;
    color: #ffffff;
    padding: 2px 8px;
    margin-left: 1rem;
  }
}

.elsa-chevron-circle-down,
.elsa-chevron-circle-up {
  display: inline-block;
  margin-bottom: -4px;
}

.tag {
  padding: 4px 8px;
  background: #efeff4;
  border-radius: 4px;
  text-transform: uppercase;
  margin-top: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.25px;
  font-variant: small-caps;
}

.level-title {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #121131;
  font-weight: 400;
}

.root-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  /*text-transform: capitalize;*/
  letter-spacing: 0.25px;
  color: #121131;
  font-family: sf-pro-text, sans-serif;
}

.level-2-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #121131;
  margin-left: 16px;
}

::v-deep .custom-tree-node .elsa-grip-lines {
  margin-top: 15px;
}

::v-deep .el-tree-node .el-tree-node {
  background: #fafafc;
}
</style>
